import Lenis from 'lenis'
import { prefersReducedMotion } from './env'

/** Thin wrapper so the rest of the app doesn't care whether smooth scrolling is on. */
export class Scroller {
  private lenis: Lenis | null = null

  constructor() {
    // Smooth wheel scrolling + block docking for everyone; reduced motion gets a snappier lerp.
    this.lenis = new Lenis({
      lerp: prefersReducedMotion() ? 0.2 : 0.095,
      smoothWheel: true,
      wheelMultiplier: 0.95,
      autoRaf: false,
    })
  }

  /** The Lenis instance, or null when smooth scrolling is off (reduced motion). */
  get instance(): Lenis | null {
    return this.lenis
  }

  get y(): number {
    return this.lenis ? this.lenis.scroll : window.scrollY
  }

  raf(time: number): void {
    this.lenis?.raf(time)
  }

  to(target: number | string | HTMLElement, offset = 0): void {
    if (this.lenis) {
      this.lenis.scrollTo(target, { offset, duration: 1.0, easing: (t: number) => 1 - Math.pow(1 - t, 3) })
      return
    }
    const el = typeof target === 'string' ? document.querySelector<HTMLElement>(target) : target
    const top = typeof el === 'number' ? el : el ? el.getBoundingClientRect().top + window.scrollY + offset : 0
    window.scrollTo({ top, behavior: prefersReducedMotion() ? 'auto' : 'smooth' })
  }

  lock(): void {
    this.lenis?.stop()
    document.documentElement.classList.add('is-locked')
  }

  unlock(): void {
    this.lenis?.start()
    document.documentElement.classList.remove('is-locked')
  }
}
